/** Bottom tab bar. */
import { Icon, type IconName } from './Icon';

export type Route = 'chat' | 'approvals' | 'todo' | 'agenda' | 'sessions' | 'settings' | 'pair';

const ITEMS: ReadonlyArray<{ route: Route; label: string; icon: IconName }> = [
  { route: 'chat', label: '聊天', icon: 'chat' },
  { route: 'approvals', label: '审批', icon: 'approvals' },
  { route: 'todo', label: '待办', icon: 'todo' },
  { route: 'agenda', label: '议程', icon: 'calendar' },
  { route: 'sessions', label: '会话', icon: 'sessions' },
  { route: 'settings', label: '设置', icon: 'settings' },
  { route: 'pair', label: '设备', icon: 'device' },
];

export function NavBar({
  route,
  pendingCount,
  onNavigate,
}: {
  route: Route;
  pendingCount: number;
  onNavigate(route: Route): void;
}) {
  return (
    <nav className="safe-bottom z-20 grid grid-cols-7 border-t border-white/10 bg-[#080d1a]/95 backdrop-blur">
      {ITEMS.map((item) => {
        const active = route === item.route;
        return (
          <button
            key={item.route}
            type="button"
            onClick={() => onNavigate(item.route)}
            className={`relative flex flex-col items-center gap-0.5 py-2.5 text-[10px] transition ${
              active ? 'text-indigo-300' : 'text-slate-500'
            }`}
            aria-current={active ? 'page' : undefined}
          >
            <Icon name={item.icon} className="h-5 w-5" />
            <span>{item.label}</span>
            {item.route === 'approvals' && pendingCount > 0 ? (
              <span className="absolute right-[calc(50%-18px)] top-1.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-rose-500 px-1 text-[9px] font-semibold text-white">
                {pendingCount > 99 ? '99+' : pendingCount}
              </span>
            ) : null}
            {active ? (
              <span className="absolute -top-px h-0.5 w-8 rounded-full bg-indigo-400" />
            ) : null}
          </button>
        );
      })}
    </nav>
  );
}
